import { render } from "./sms-dropdown.vue?vue&type=template&id=71030f27&scoped=true"
import script from "./sms-dropdown.vue?vue&type=script&lang=js"
export * from "./sms-dropdown.vue?vue&type=script&lang=js"

import "./sms-dropdown.vue?vue&type=style&index=0&id=71030f27&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71030f27"]])

export default __exports__